import './DataAccessSearchItems.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NoData } from '@ui/NoData';
import { useSonarSelector } from '@hooks';
import { DataAccessType, DataAccessTypePlural } from '@sonar-software/sonar-core';
import React, { useMemo } from 'react';
export const dataAccessSearchDataSelector = createAsyncSelectors((state) => state.core.dataSecurity.dataAccess.search.get);
export const targetObjectTypeOrder = [
    DataAccessType.Object
];
function getSortedDataKeys(data) {
    if (!data) {
        return [];
    }
    const keys = Object.keys(data).filter((item) => targetObjectTypeOrder.indexOf(item) > -1);
    return keys.sort((a, b) => targetObjectTypeOrder.indexOf(a) - targetObjectTypeOrder.indexOf(b));
}
export const DataAccessSearchItems = ({ currentType, onTypeSelection }) => {
    const data = useSonarSelector(dataAccessSearchDataSelector.data);
    const isRequested = useSonarSelector(dataAccessSearchDataSelector.isRequested);
    const searchDataKeys = useMemo(() => getSortedDataKeys(data), [data]);
    if (isRequested) {
        return React.createElement(LoadingSpinner, null);
    }
    let dataAccessSearchItems;
    if (!data || !searchDataKeys.length) {
        if (currentType) {
            dataAccessSearchItems =
                React.createElement("div", { className: 'header' },
                    React.createElement("span", null, DataAccessTypePlural[currentType]),
                    React.createElement(NoData, { className: 'data-access-search-items-empty', imageName: 'default' }));
        }
        else {
            dataAccessSearchItems = React.createElement(NoData, { className: 'data-access-search-items-empty', imageName: 'default' });
        }
    }
    else {
        dataAccessSearchItems = searchDataKeys.map((type) => {
            const items = data[type];
            const header = DataAccessTypePlural[type];
            const showSeeMore = !currentType;
            return (React.createElement("div", { className: 'data-access-search-type-grouping', key: type },
                React.createElement("div", { className: 'header' },
                    React.createElement("span", null, header),
                    showSeeMore &&
                        React.createElement("span", { className: 'show-more-link', onClick: () => onTypeSelection(type) }, COPY_GENERIC.SHOW_MORE)),
                items.map((item) => React.createElement("div", { className: 'data-access-search-item', key: item.id },
                    React.createElement("div", { className: 'name' }, item.display)))));
        });
    }
    return React.createElement("div", { id: 'data-access-search-items' }, dataAccessSearchItems);
};
